import { safeRead } from '@planity/helpers';
import { TextSection } from './text_section';

const renderTextSections = category => {
	const texts = safeRead(category, ['texts', 'sections'], { value: [] });
	return texts.map((text, index) => <TextSection key={index} {...text} />);
};

export default renderTextSections;
